var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportPieChart',{ref:"statusChart",attrs:{"height":_vm.height,"width":_vm.width,"report-data":_vm.reportData,"legend":_vm.legend,"show-percentages":true,"title":"Corruption Cases by Status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }